






































import { Component, Vue } from "vue-property-decorator";
import viewBox from "@/components/viewBox.vue";
import request from "@/api/index";
@Component({
  components: { viewBox }
})
export default class Index extends Vue {
  mounted() {
    document.title = "湿地植物培育";
  }

  topage(path: string) {
    this.$router.push(path);
  }
}
